import qualitiesJson from "../../data/performanceMarketingQualities.json";
import qualitiesJson2 from "../../data/performanceMarketingQualities2.json";

export default function Section5() {
  const bgImage = {
    backgroundImage: "url('assets/magento-rectangle.png')",
  };

  const qualitiesData = qualitiesJson;

  const qualitiesData2 = qualitiesJson2;

  return (
    <div
      className="Section5 p-[2%] my-[40px] md:mb-[4%] md:mt-[5%] text-center"
      style={bgImage}
    >
      <div className="section5-container">
        <h2 className="md:text-[34px] text-[24px] font-bold leading-[32px] md:leading-[41px] text-white my-[0.67em]">
          Why Choose Us?
        </h2>

        <div className="md:pt-5">
          <div className="flex flex-col md:flex-row md:justify-around w-[80%] mx-auto md:mb-[25px]">
            {qualitiesData.map(({ title, text, list }, index) => {
              return (
                <div
                  key={title + index}
                  className="bg-white rounded-[10px] md:w-1/3 p-[15px_20px] my-[10px] md:m-[10px_8px] text-center"
                >
                  <h3 className="text-[16px] leading-[26px] font-bold text-black my-[0.67em]">
                    {title}
                  </h3>
                  <p className="text-[14px] text-[#373737] mb-5 font-open">
                    {text}

                    {list?.map((item, index2) => (
                      <span key={item + index2} className="block">
                        {item}
                      </span>
                    ))}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="flex flex-col md:flex-row md:justify-around w-[80%] mx-auto mb-[10px] md:mb-[25px]">
            {qualitiesData2.map(({ title, text, list }, index) => {
              return (
                <div
                  key={title + index}
                  className="bg-white rounded-[10px] md:w-1/3 p-[15px_20px] my-[10px] md:m-[10px_8px] text-center"
                >
                  <h3 className="text-[16px] leading-[26px] font-bold text-black my-[0.67em]">
                    {title}
                  </h3>
                  <p className="text-[14px] text-[#373737] mb-5 font-open">
                    {text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
